// App Store / Google Play links are live.
export const APP_IS_LIVE = true;

export const APP_STORE_URL = "https://apps.apple.com/us/app/genesis-recovery-ai/id6759672013";
export const GOOGLE_PLAY_URL =
    "https://play.google.com/store/apps/details?id=com.genesis.recovery.ai";
export const WAITLIST_HREF = "/contact#download";
